import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ModalFilterTextData } from '@shared/components/usf-filtering-modal/model/modal-filter';
import { UsfFilteringOptionComponent } from '@shared/components/usf-filtering-modal/usf-filtering-options/usf-filtering-option/usf-filtering-option-component';

@Component({
  selector: 'app-usf-filter-text-entry-desktop',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './usf-filtering-text-entry-options.component.html',
  styleUrls: ['./usf-filtering-text-entry-options.component.scss'],
})
export class UsfFilterTextEntryOptionsComponent
  extends UsfFilteringOptionComponent<ModalFilterTextData, string>
  implements OnInit
{
  maxLength: number;

  ngOnInit(): void {
    this.maxLength = this.extractDigitQuantifier(
      this.data.validationRegex,
    )?.max;
  }

  onTextEntryChange() {
    this.optionSelected.emit(this.data.searchText);
  }

  extractDigitQuantifier(regex: RegExp): { min: number; max: number } | null {
    const regexStr = regex.toString();
    const rangeMatch = regexStr.match(/\{(\d+),(\d+)\}/);
    if (rangeMatch) {
      return {
        min: parseInt(rangeMatch[1], 10),
        max: parseInt(rangeMatch[2], 10),
      };
    }
    const exactMatch = regexStr.match(/\{(\d+)\}/);
    if (exactMatch) {
      const value = parseInt(exactMatch[1], 10);
      return { min: value, max: value };
    }

    return null;
  }
}
